import React, {useEffect, useState} from 'react';
import {useOrganization} from "../organizations/organization-context";
import {useTranslation} from 'react-i18next';
import {useApiNotification} from "../ui/ApiNotificationProvider";
import Link from '@material-ui/core/Link';
import {Link as RouterLink} from 'react-router-dom';
import UsersList from "../_shared/UsersList";
import {run} from "../../utils/function-util";
import {getAdmins} from "../../api/organization-unit-admin-functions";


const AdminsList = () => {
    const {t} = useTranslation();
    const [admins, setAdmins] = useState([]);
    const {handleError} = useApiNotification();
    let [currentOrganization] = useOrganization();

    useEffect(run(() => currentOrganization ? getAdmins(currentOrganization.id) : Promise.resolve([]),
        setAdmins,
        handleError
    ), []);

    if(!currentOrganization) return null;

    return (
               <UsersList users={admins}
                   actionColumn={
                                             (user: any) => <Link
                           component={RouterLink}
                           underline={'always'}
                           variant={'button'}
                           color={'primary'}
                           to={`/admins/${user.userId}`}>
                           {t('_Common.Labels.Open')}
                       </Link>
                   }
        />
    );
};

export default AdminsList;
